document.addEventListener('DOMContentLoaded', () => {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!policyBody) return;

  const corrections = [
    ['appplicable', 'applicable'],
    ['newletters', 'newsletters'],
    ['Etre', 'Être'],
    ['GCI', 'CGI'],
    ['junglehoodecbdet', 'junglehoodecbd et'],
  ];

  const walker = document.createTreeWalker(policyBody, NodeFilter.SHOW_TEXT);
  let textNode;

  while ((textNode = walker.nextNode())) {
    let correctedText = textNode.nodeValue;

    for (const [mistake, correction] of corrections) {
      correctedText = correctedText.replaceAll(mistake, correction);
    }

    if (correctedText !== textNode.nodeValue) {
      textNode.nodeValue = correctedText;
    }
  }
});
